export default {"src":"/_next/static/media/lifeinsurancecalc.fddd8e58.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};